import React from 'react'
import { CardBrands } from '../../../../CardBrands'

const PointsCashCardBrands = ({ brands }) => (
  <div className='col-12 col-md-6 txt-right'>
    <div className='product-payment border-none mx-0'>
      <CardBrands brands={brands} />
    </div>
  </div>
)

PointsCashCardBrands.propTypes = CardBrands.propTypes

export default PointsCashCardBrands



// WEBPACK FOOTER //
// ./src/features/Checkout/Payment/Body/PointsCash/PointsCashCardBrands.js